import React from 'react';
import { ListGroup, Card } from 'react-bootstrap';

function VideoList({
  onVideoSelect,
  videoProgress,
  currentVideoId,
  videos = [],
  headerHtml = 'H<sub>2</sub>S Academy',
}) {

  const categories = [...new Set((Array.isArray(videos) ? videos : []).map((video) => video.category))];

  return (
    <div className="video-list">
      <Card.Header className="head">
        <span dangerouslySetInnerHTML={{ __html: headerHtml }} />
      </Card.Header>
      {categories.map((category) => (
        <Card key={category}>
          <Card.Header>{category}</Card.Header>
          <ListGroup variant="flush">
            {videos.filter((video) => video.category === category).map((video) => (
              <ListGroup.Item
                key={video.id}
                action
                onClick={() => onVideoSelect(video)}
                className={
                  currentVideoId === video.id
                    ? 'fw-bold'
                    : videoProgress[video.id] >= 100
                    ? 'completed-video'
                    : ''
                }
              >
                <i
                  className={`bi ${
                    video.hasBeenViewed ? 'bi-check-circle-fill' : 'bi-circle text-secondary'
                  } me-2`}
                ></i>
                {video.title}
                {videoProgress[video.id] >= 100 && <span className="badge bg-success ms-2">Completed</span>}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      ))}
    </div>
  );
}

export default VideoList;
